function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.345 14.471a.78.78 0 00-.65-.217h-9.323v-4.12a7.372 7.372 0 10-14.744 0v4.12H3.305c-.26 0-.52 0-.65.217a.737.737 0 00-.217.65l3.252 17.78a5.29 5.29 0 005.117 4.336h18.386a5.334 5.334 0 005.117-4.38l3.252-17.736a.737.737 0 00-.217-.65zm-22.982-4.336a5.637 5.637 0 0111.274 0v4.12H14.363v-4.12zM32.575 32.64a3.47 3.47 0 01-3.382 2.862H10.807a3.468 3.468 0 01-3.382-2.862L4.346 15.989h31.308L32.575 32.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.505 24.445a.867.867 0 00.867-.867v-2.602a.867.867 0 10-1.734 0v2.602a.867.867 0 00.867.867zM13.496 24.445a.867.867 0 00.867-.867v-2.602a.867.867 0 10-1.734 0v2.602a.867.867 0 00.867.867z"
}))));

function SvgBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/bag.ba01a351.svg";
export { SvgBag as ReactComponent };